import React from "react";
import {
  Toolbar,
  CssBaseline,
  AppBar,
  IconButton,
  Avatar,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Accountmenu from "../accounts/AccountMenu";
import { useState } from "react";
import accountLogo from "../../../assets/images/new_user.jpg";

const drawerWidth = 260;

function AppHeader({ handleDrawerToggle }) {
  //   const { userInfo } = useAdminContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          background: "#181921",
        }}
        elevation={0}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <div className="d-flex align-items-center w-100 "></div>
          <div className="" style={{ marginRight: "0px !important" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={handleMenuOpen}
            >
              <Avatar sx={{ width: 50, height: 50, border: "none" }} />
              {open ? (
                <ExpandLess
                  sx={{
                    position: "absolute",
                    backgroundColor: "white",
                    color: "black",
                    bottom: 1,
                    right: -5,
                    fontSize: "15px",
                    borderRadius: "50px",
                  }}
                />
              ) : (
                <ExpandMore
                  sx={{
                    backgroundColor: "white",
                    color: "black",
                    position: "absolute",
                    bottom: 1,
                    right: -5,
                    fontSize: "15px",
                    borderRadius: "50px",
                  }}
                />
              )}{" "}
            </Box>
          </div>

          <Accountmenu
            anchorEl={anchorEl}
            open={open}
            handleClose={handleClose}
          />
        </Toolbar>
      </AppBar>
    </>
  );
}

export default AppHeader;
